import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CurrentService } from '../current.service';

@Injectable({
  providedIn: 'root',
})
export class StorageInspirationGuard {
  constructor(
    private current: CurrentService,
    private router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.current.storage.inspirationId <= 0) {
      this.router.navigate(['/rangements']);
      return false;
    }
    return true;
  }
}
